import { React } from "react";
import { useFetchData } from "helpers/utils";
import Single from "components/globals/image/Single";
import { usePostPane } from '../../../providers/PostPaneContext';


const CarMods = ({id}) => {
	
	const { data: mods, loading, error } = useFetchData(
		`${process.env.REACT_APP_SERVER_URI}/api/car/mods/${id}`,
		[id],
	);

	const { openPostPane } = usePostPane();
		
	const triggerPostPane = (item) => {
		openPostPane({ item: item });
	};

	// Loading & error states
	if (loading) return <div>Loading...</div>;
	if (error) return <div>Error: {error.message}</div>;

	return (
		<>
			{mods?.entries.length > 0 && !loading && (
				<>
					<h3 className=" text-xl mt-6 mb-3">Mods</h3>
					<div className="grid grid-cols-2 md:grid-cols-3 gap-3 my-sm">
						{mods?.entries.map((mod) => (
							<div 
								className="bg-black relative rounded-default overflow-hidden aspect-[4/2] flex items-end" 
								key={mod.internal_id}
								onClick={(e) => {
										e.preventDefault();
										triggerPostPane(mod);
									}}>
								<Single
									className="absolute inset-0 bg-cover"
									image={mod.gallery[0]}
								/>
								<div className="flex items-center w-full relative z-[2] py-3 px-3 bg-[#303030] bg-opacity-60">
									<div className="grow">
										<span className="block text-[16px]  text-white">{mod.title}</span>
										<span className="block text-[10px]  text-white">{mod.type}</span>
									</div>
								</div>
							</div>
						))}
					</div>
				</>
			)}
		</>
	);
};

export default CarMods;